<div [ngClass]="langDirection">
  <mi-request></mi-request>
</div>